import { MenuItem, Select } from "@mui/material";

const FilterOrderByMonth = ({ setFilters, filters }) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();

  const handleSelect = (event) => {
    const [month, year] = event.target.value.split("-").map(Number);
    setFilters((prev) => ({ ...prev, month, year }));
  };

  // Determine current value for Select
  let selectValue = "0-0"; // default "Select Month"
  if (filters.month && filters.year) {
    selectValue = `${filters.month}-${filters.year}`;
  }

  return (
    <Select size="small" value={selectValue} onChange={handleSelect}>
      <MenuItem value="0-0">Select Month</MenuItem>
      <MenuItem value={`${currentMonth}-${currentYear}`}>This Month</MenuItem>
      <MenuItem
        value={`${currentMonth === 1 ? 12 : currentMonth - 1}-${currentMonth === 1 ? currentYear - 1 : currentYear}`}
      >
        Last Month
      </MenuItem>
    </Select>
  );
};

export default FilterOrderByMonth;
